window.addEventListener('DOMContentLoaded', function() {

  // ============================================================================================
  // 商品詳細ページ レビュー表示の移動
  // ============================================================================================
  // 特定の要素が表示されるまで待つ関数
  function waitForElm(selector, timeout = 10000) {
    return new Promise((resolve, reject) => {
      const element = document.querySelector(selector);
      if (element) {
        return resolve(element);
      }

      const observer = new MutationObserver((mutations, obs) => {
        const el = document.querySelector(selector);
        if (el) {
          obs.disconnect();
          resolve(el);
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });

      setTimeout(() => {
        observer.disconnect();
        reject(new Error(`Element ${selector} not found within ${timeout}ms`));
      }, timeout);
    });
  }

  // 対象セクションの存在確認
  if (document.querySelector('.sbn-p-section-template-customer')) {
    // 星評価の移動処理
    Promise.all([
      waitForElm('.sbn-p-section-template-customer .star-ratings-css'),
      waitForElm('.sbn-p-section-template-customer .sbn-c-list-rating__viewport')
    ])
      .then(([starRatingsCss, listRatingViewport]) => {
        if (!listRatingViewport.contains(starRatingsCss)) {
          listRatingViewport.appendChild(starRatingsCss);
        }
      })
      .catch(err => {
        console.error('星評価の移動に失敗:', err);
      });

    // レビュー件数の更新処理
    waitForElm('.sbn-p-section-template-customer .mxpr-summary__count')
      .then((reviewCountElement) => {
        // 「0件のレビュー」から数字を抽出
        const countText = reviewCountElement.textContent;
        const count = countText.match(/(\d+)件/)?.[1] || '0';

        // 件数表示要素を更新
        const ratingAmount = document.querySelector('.sbn-p-section-template-customer .sbn-c-list-rating__amount');
        if (ratingAmount) {
          ratingAmount.innerHTML = `<span class="sbn-u-pc">件数 </span><span class="sbn-u-sp">（</span>${count}件<span class="sbn-u-sp">）</span>`;
        }
      })
      .catch(err => {
        console.error('レビュー件数の取得に失敗:', err);
      });
  }

  // ============================================================================================
  // 商品詳細 関連商品スライダー
  // ============================================================================================
  let recommendSwiper = null;

  function initRecommendSwiper(element) {
    const slider = $(element);
    const sliderViewport = slider.find('.swiper');
    const sliderArrowNext = slider.find('[data-slider-role="arrow-next"]');
    const sliderArrowPrevious = slider.find('[data-slider-role="arrow-previous"]');

    recommendSwiper = new Swiper(sliderViewport[0], {
      loop: false,
      spaceBetween: 0,
      slidesPerView: 'auto',
      speed: 500,
      fade: true,
      navigation: {
        nextEl: sliderArrowNext[0],
        prevEl: sliderArrowPrevious[0]
      }
    });
  }

  function waitForRecommendSlider() {
    return new Promise(resolve => {
      // まず即座にチェック
      const element = document.querySelector('.sbn-js-slider-recommend');
      if (element) {
        return resolve(element);
      }

      // 要素が見つからない場合は、MutationObserverで監視
      const observer = new MutationObserver(() => {
        const element = document.querySelector('.sbn-js-slider-recommend');
        if (element) {
          observer.disconnect();
          resolve(element);
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    });
  }

  async function initializeRecommendSlider() {
    try {
      const element = await waitForRecommendSlider();
      initRecommendSwiper(element);
    } catch (error) {
      console.error('Failed to initialize recommend slider:', error);
    }
  }

  // 初期化を実行
  initializeRecommendSlider();

});



// ============================================================================================
// 商品詳細 メディアスライダー
// ============================================================================================
window.addEventListener('DOMContentLoaded', function() {
  const modalSlider = document.querySelector('.sbn-js-slider-modal [data-slider-role="showcase"]');
  const prevButton = document.querySelector('.sbn-js-slider-modal [data-slider-role="showcase-arrow-previous"]');
  const nextButton = document.querySelector('.sbn-js-slider-modal [data-slider-role="showcase-arrow-next"]');

  modalSwiper = new Swiper(modalSlider, {
    loop: true,
    slidesPerView: 'auto', // 自動でスライド数を調整
    centeredSlides: true, // スライドを中央に配置
    speed: 500, // スライドの移動速度
    navigation: {
      nextEl: nextButton,
      prevEl: prevButton,
    },
  });
});

// ------------------------------------------------
// モーダル
// ------------------------------------------------
// モーダルを初期化する関数
const initializeModal = (modal) => {
  if (!modal) {
    // console.error("Element required for initializeModal is not found.");
    return;
  }

  const openTriggers = document.querySelectorAll(
    `[data-modal-open="${modal.id}"]`
  );
  const closeTriggers = modal.querySelectorAll("[data-modal-close]");

  // if (openTriggers.length === 0 || closeTriggers.length === 0) {
  if (openTriggers.length === 0 ) {
    // console.error("Elements required for modal trigger are not found.");
    return;
  }

  openTriggers.forEach((trigger) => {
    trigger.addEventListener(
      "click",
      (event) => handleOpenTriggerClick(event, modal, trigger),
      false
    );
    trigger.addEventListener("mousedown", handleTriggerFocus, false);
    trigger.addEventListener("keydown", handleTriggerFocus, false);
  });

  // closeTriggers.forEach((trigger) => {
  //   trigger.addEventListener(
  //     "click",
  //     (event) => handleCloseTriggerClick(event, modal),
  //     false
  //   );
  // });
  if (closeTriggers.length > 0) {
    closeTriggers.forEach((trigger) => {
      trigger.addEventListener(
        "click",
        (event) => handleCloseTriggerClick(event, modal),
        false
      );
    });
  }

  modal.addEventListener(
    "click",
    (event) => handleBackdropClick(event, modal),
    false
  );
};

// モーダルのアニメーションが完了するのを待つ
const waitModalAnimation = (modal) => {
  if (modal.getAnimations().length === 0) return Promise.resolve([]);
  return Promise.allSettled(
    modal.getAnimations().map((animation) => animation.finished)
  );
};

const eventListenersMap = new Map();

// イベントリスナーの管理
const manageEventListeners = (modal, add) => {
  const keyDownListener = (event) => handleKeyDown(event, modal);

  if (add) {
    window.addEventListener("keydown", keyDownListener, false);
    eventListenersMap.set(modal, { keyDownListener });
  } else {
    const listeners = eventListenersMap.get(modal);
    if (listeners) {
      window.removeEventListener("keydown", listeners.keyDownListener);
      eventListenersMap.delete(modal);
    }
  }
};

let currentOpenTrigger = null;

// トリガーのクリックイベントハンドラ
const handleOpenTriggerClick = (event, modal, trigger) => {
  event.preventDefault();
  currentOpenTrigger = trigger;
  openModal(modal);
};

const handleCloseTriggerClick = (event, modal) => {
  event.preventDefault();
  closeModal(modal);
};

// トリガーのフォーカスイベントハンドラ
const handleTriggerFocus = (event) => {
  if (event.type === "mousedown") {
    document.documentElement.setAttribute("data-mousedown", "true");
  }
  if (event.type === "keydown") {
    document.documentElement.removeAttribute("data-mousedown");
  }
};

// モーダルの背景クリックイベントハンドラ
const handleBackdropClick = (event, modal) => {
  if (event.target === modal) {
    closeModal(modal);
  }
};

// キーダウンイベントハンドラ
const handleKeyDown = (event, modal) => {
  document.documentElement.removeAttribute("data-mousedown");
  if (event.key === "Escape") {
    event.preventDefault();
    closeModal(modal);
  }
};

let isTransitioning = false;

// モーダルを開く
const openModal = (modal) => {
  if (isTransitioning) return;

  isTransitioning = true;
  modal.showModal();
  backfaceFixed(true);
  manageEventListeners(modal, true);

  requestAnimationFrame(async () => {
    modal.setAttribute("data-active", "true");
    await waitModalAnimation(modal);
    isTransitioning = false;
  });
};

// モーダルを閉じる
const closeModal = async (modal) => {
  if (isTransitioning) return;

  isTransitioning = true;
  modal.setAttribute("data-active", "false");
  backfaceFixed(false);
  manageEventListeners(modal, false);

  await waitModalAnimation(modal);
  modal.close();

  if (currentOpenTrigger) {
    currentOpenTrigger.focus();
    currentOpenTrigger = null;
  }

  isTransitioning = false;
};

// ドキュメントの書字方向を取得し、縦書きかどうかを判定
const isVerticalWritingMode = () => {
  const writingMode = window.getComputedStyle(
    document.documentElement
  ).writingMode;
  return writingMode.includes("vertical");
};

// スクロールバーの幅を計算する
const getScrollBarSize = () => {
  const scrollBarXSize =
    window.innerWidth - document.documentElement.clientWidth;
  const scrollBarYSize =
    window.innerHeight - document.documentElement.clientHeight;
  return isVerticalWritingMode() ? scrollBarXSize : scrollBarYSize;
};

// スクロール位置を取得する
const getScrollPosition = (fixed) => {
  if (fixed) {
    return isVerticalWritingMode()
      ? window.pageXOffset || document.documentElement.scrollLeft
      : window.pageYOffset || document.documentElement.scrollTop;
  }
  return parseInt(document.body.style.top || "0", 10);
};

// 背面固定のスタイルを適用する
const applyStyles = (scrollPosition, apply) => {
  const styles = {
    height: "100%",
    left: "0",
    position: "fixed",
    top: `-${scrollPosition}px`,
    width: "100%",
  };

  Object.entries(styles).forEach(([key, value]) => {
    document.body.style[key] = apply ? value : "";
  });
};

// 背面固定の処理
const backfaceFixed = (fixed) => {
  if (fixed) {
    document.body.style.height = "100%";
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.height = "";
    document.body.style.overflow = "";
  }
};

// DOMContentLoadedイベントで初期化を行う
document.addEventListener("DOMContentLoaded", () => {
  const modal = document.getElementById("modal1");

  if (modal) {
    initializeModal(modal);

    const handleResize = () => {
      if (window.innerWidth <= 768 && modal.hasAttribute('open')) {
        closeModal(modal);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
  }
});



// ============================================================================================
// 店舗検索ページ
// ============================================================================================
document.addEventListener('DOMContentLoaded', function() {

  const form = document.querySelector('.sbn-p-form-pageshops-conditions__wrapper');
  const prefectureSelect = document.querySelector('select[name="prefecture"]');
  const keywordsInput = document.querySelector('input[name="keywords"]');
  const pcSubItems = document.querySelectorAll('.pc-only .sbn-p-form-pageshops-conditions__controller-notice__subitem');
  const spSelect = document.querySelector('.sp-only select');
  const selectedBoxText = document.querySelector('.sbn-js-selected-box .sbn-p-form-pageshops-conditions__controller-notice__text');
  const selectedBoxClose = document.querySelector('.sbn-js-selected-box-close');
  const hiddenLandInput = document.querySelector('.selected-land-input');

  // selectedBox を表示する
  function showSelectedBox() {
    selectedBoxText.parentElement.parentElement.style.opacity = '1';
    selectedBoxText.parentElement.parentElement.style.visibility = 'visible';
    selectedBoxText.parentElement.parentElement.style.pointerEvents = 'auto';
  }

  // selectedBox を非表示にする
  function hideSelectedBox() {
    selectedBoxText.parentElement.parentElement.style.opacity = '0';
    selectedBoxText.parentElement.parentElement.style.visibility = 'hidden';
    selectedBoxText.parentElement.parentElement.style.pointerEvents = 'none';
  }

  // PC用ランドセル選択イベント
  pcSubItems.forEach(function(item) {
    item.addEventListener('click', function(e) {
      e.preventDefault();

      const selectedHandle = this.getAttribute('data-product-id');
      const selectedText = this.textContent.trim();
      selectedBoxText.textContent = selectedText;

      hiddenLandInput.value = selectedHandle;

      showSelectedBox();
      const details = this.closest('details');
      if (details) {
        details.removeAttribute('open');
      }
    });
  });

  // SP用ランドセル選択イベント
  if (spSelect) {
    spSelect.addEventListener('change', function() {
      const selectedHandle = this.value;
      const selectedText = this.options[this.selectedIndex].text;

      if (selectedHandle) {
        selectedBoxText.textContent = selectedText;
        hiddenLandInput.value = selectedHandle;
        showSelectedBox();
        this.value = '';
      }
    });
  }

  if (selectedBoxClose) {
    selectedBoxClose.addEventListener('click', function() {
      hideSelectedBox();
      selectedBoxText.textContent = '人気のランドセルから選ぶ';
      hiddenLandInput.value = '';
    });
  }

  // フォーム送信時の処理
  if (form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();

      const selectedPrefecture = prefectureSelect.value;
      const selectedPrefectureIndex = prefectureSelect.selectedIndex;
      const selectedPrefectureName = prefectureSelect[selectedPrefectureIndex].innerText;
      const selectedLand = hiddenLandInput.value;
      const keywords = keywordsInput.value.trim();
      const baseUrl = `https://seiban.myshopify.com/pages/shops-list`;
      const params = new URLSearchParams();

      if(selectedPrefecture) {
        params.append('prefecture',selectedPrefectureName);
      }

      if (keywords) {
        params.append('keyword', keywords);
      }

      if (selectedLand) {
        params.append('product', selectedLand);
      }

      const targetUrl = `${baseUrl}?${params.toString()}`;

      window.location.href = targetUrl;
    });
  }

  const detailsElements = document.querySelectorAll('details');

  detailsElements.forEach(function(details) {
    details.addEventListener('toggle', function() {
      if (details.open) {
        hideSelectedBox();
      } else {

        if (hiddenLandInput.value) {
          showSelectedBox();
        }
      }
    });
  });
});

// ============================================================================================
// TOP 店舗検索
// ============================================================================================
document.addEventListener('DOMContentLoaded', function() {
  const form = document.getElementById('topStoreSearchForm');
  const keywordsInput = document.getElementById('topStoreKeywords');
  if(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();

      const keywords = keywordsInput.value.trim();
      const baseUrl = `https://seiban.myshopify.com/pages/shops-list`;
      const params = new URLSearchParams();

      if (keywords) {
        params.append('keyword', keywords);
        const targetUrl = `${baseUrl}?${params.toString()}`;
        window.location.href = targetUrl;
      }
    });
  }
});

// ============================================================================================
// 店舗検索結果 店舗再検索
// ============================================================================================
document.addEventListener('DOMContentLoaded', function() {
  const form = document.getElementById('re-searchForm');
  const prefectureSelect = document.querySelector('select[name="prefecture"]');
  const keywordsInput = document.getElementById('re-searchStoreKeywords');
  const girlRandSelect = document.getElementById('re-selectGirl');
  const boyRandSelect = document.getElementById('re-selectBoy');

  // 女の子セレクトボックスが変更された時
  girlRandSelect?.addEventListener('change', function() {
    if (this.value !== '') {
      boyRandSelect.selectedIndex = 0;
    }
  });

  // 男の子セレクトボックスが変更された時
  boyRandSelect?.addEventListener('change', function() {
    if (this.value !== '') {
      girlRandSelect.selectedIndex = 0;
    }
  });

  // フォーム送信時処理
  if(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();

      const selectedPrefecture = prefectureSelect.value;
      const selectedPrefectureIndex = prefectureSelect.selectedIndex;
      const selectedPrefectureName = prefectureSelect[selectedPrefectureIndex].innerText;
      const keywords = keywordsInput.value.trim();
      let selectedProduct = girlRandSelect.value;
      if(!selectedProduct) selectedProduct = boyRandSelect.value;

      const baseUrl = `https://seiban.myshopify.com/pages/shops-list`;
      const params = new URLSearchParams();

      if(selectedPrefecture) {
        params.append('prefecture',selectedPrefectureName);
      }

      if (keywords) {
        params.append('keyword', keywords);
      }

      if(selectedProduct) {
        params.append('product', selectedProduct);
      }

      const targetUrl = `${baseUrl}?${params.toString()}`;
      window.location.href = targetUrl;

    });
  }
});

{
  const alertMessageButton = document.querySelector('.js-alert-message-button');
  if (alertMessageButton) {
    alertMessageButton.addEventListener('click', function() {
      const alertMessage = alertMessageButton.dataset.alertMessage;
      alert(alertMessage);
    }, false)
  }
}
